import { ChamadoEvidenciaService } from '@/features/chamados/services/chamado-evidencia.service'
import { CallEvidenceImage } from '@/services/backend/config/entities'

import { EvidenceCreateDialog } from './evidence-create-dialog'

type Props = {
  callId: number
  onSuccess: (data: CallEvidenceImage) => void
}

export default function Component(props: Props) {
  return (
    <EvidenceCreateDialog {...props} repository={ChamadoEvidenciaService} />
  )
}
